import { size } from 'mol-ui';
import styled from 'styled-components';

export const CalendarContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    ${ size.xs(`
        flex-direction: column;
    `) };
`;

